import $ from 'jquery'
import Interact from 'interactjs'
import { Store } from 'vuex'
import RootState from '../../store/state'
import Draggable, { DraggableOption } from './Draggable'
import Droppable, { DroppableOption } from './Droppable'

export default class InteractableComponent {
  private interactable: Interact.Interactable
  private draggableImpl?: Draggable
  private droppableImpl?: Droppable

  constructor(private readonly element: HTMLElement | string, private readonly store: Store<RootState>) {
    this.interactable = Interact($(this.element).get(0))
  }

  draggable(option?: DraggableOption): Draggable {
    if (this.draggableImpl && option) {
      throw new Error('既に Draggable になっています。 Option の上書きはできません。')
    }
    if (!this.draggableImpl) {
      this.draggableImpl = new Draggable(this.element, this.interactable, this.store, option)
    }
    return this.draggableImpl
  }

  droppable(option?: DroppableOption): Droppable {
    if (this.droppableImpl && option) {
      throw new Error('既に Droppable になっています。 Option の上書きはできません。')
    }
    if (!this.droppableImpl) {
      this.droppableImpl = new Droppable(this.element, this.interactable, this.store, option)
    }
    return this.droppableImpl
  }

  public destroy(): void {
    this.interactable.unset()
    this.draggableImpl = undefined
    this.droppableImpl = undefined
  }
}
